import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sugargoo-spreadsheet-guide",
    element: <Navigate to="/article/sugargoo-spreadsheet-complete-guide" replace />,
  },
  {
    path: "/article/:slug",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;